price-checkboxes.price-checkboxes
  .checkboxes(class="{props.type} {props.mobile ? 'sp' : 'pc'}")
    .labels
      template(if!="{state.priceranges.length > 0}")
        template(each="{(priceRange, index) in state.priceranges}")
          label(class="{priceRange['price_range_string'].includes('以') || priceRange['price_range_string'].includes('未') ? 'with-blank' : ''}")
            template(if="{ props.type === 'in_modal' }")
              img(src="{checkboxOnIcon}" class!="checkbox-icon { state.priceRangeQuery && state.priceRangeQuery.includes(priceRangeQuery(priceRange)) ? '' : 'hidden' }")
              img(src="{checkboxOffIcon}" class!="checkbox-icon { state.priceRangeQuery && state.priceRangeQuery.includes(priceRangeQuery(priceRange)) ? 'hidden' : '' }")
            input(type="checkbox" onchange="{didChangePriceRange}" name="pr[{index}]" value="{priceRangeQuery(priceRange)}"
                  checked="{state.existPriceRanges.includes(priceRangeQuery(priceRange))}")
            template(if="{!props.useLink || state.existPriceRanges.includes(priceRangeQuery(priceRange))}")
              | { priceRange["price_range_string"] }
            template(if!="{props.useLink && !state.existPriceRanges.includes(priceRangeQuery(priceRange))}")
              a(href="{urlFromValueWithFormData(priceRangeQuery(priceRange))}" rel="{props.shouldnofollow ? 'nofollow' : ''}") { priceRange["price_range_string"] }
      template(if="{state.priceranges.length === 0}")
        template(each="{(priceRangeMaster, index) in state.priceRangeMasters}")
          label(class="{priceRangeMaster.text.includes('以') ? 'with-blank' : ''}")
            template(if="{ props.type === 'in_modal' }")
              img(src="{checkboxOnIcon}" class!="checkbox-icon { state.priceRangeQuery && state.priceRangeQuery.includes(priceRangeMaster.range) ? '' : 'hidden' }")
              img(src="{checkboxOffIcon}" class!="checkbox-icon { state.priceRangeQuery && state.priceRangeQuery.includes(priceRangeMaster.range) ? 'hidden' : '' }")
            input(type="checkbox" onchange="{didChangePriceRange}" name="pr[{index}]" value="{priceRangeMaster.range}"
                  checked="{state.existPriceRanges.includes(priceRangeMaster.range)}")
            template(if="{!props.useLink || state.existPriceRanges.includes(priceRangeMaster.range)}")
              | { priceRangeMaster.text }
            template(if!="{props.useLink && !state.existPriceRanges.includes(priceRangeMaster.range)}")
              a(href="{urlFromValueWithFormData(priceRangeMaster.range)}" rel="{props.shouldnofollow ? 'nofollow' : ''}") { priceRangeMaster.text }
    .selects
      input(type="hidden" name="pr[12]" value="{state.selectedPriceRange}")
      .select-wrap
        select(name="price_bottom" id="price_bottom" onchange="{didSelectPriceRange}")
          option
          option(value="0" selected="{'0' == state.initialBottom}") 下限なし
          option(each="{priceMaster in state.priceMasters}" value="{priceMaster.price}" selected="{priceMaster.price == state.initialBottom}") { priceMaster.text }
      | &nbsp;〜&nbsp;
      .select-wrap
        select(name="price_top" id="price_top" onchange="{didSelectPriceRange}")
          option
          option(value="999999999" selected="{'999999999' == state.initialTop}") 上限なし
          option(each="{priceMaster in state.priceMasters.slice()}" value="{priceMaster.price}" selected="{priceMaster.price == state.initialTop}") { priceMaster.text }
  style(type="scss").
    .checkboxes {
      margin-top: 10px;
      .labels {
        display: flex;
        flex-wrap: wrap;
        label.with-blank {
          width: 100%;
          padding: 0;
          margin: 0;
          &:after { content: ''; }
        }
      }
      .selects {
        select {
          color: #015205;
          font-weight: bold;
          border-color: #c8c8c8;
        }
      }
      &.pc {
        .selects {
          display: flex;
          justify-content: center;
          align-items: baseline;
        }
        .labels {
          display: flex;
          flex-wrap: wrap;
          column-gap: 10px;
          label {
            margin-bottom: 5px;
            min-width: 84px;
            input {
              margin-right: 9px;
            }
            a {
              font-size: 12px;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
      &.sp {
        margin-top: 16px;
        border-top: 2px solid #e8e8e8;
        padding: 16px 0;
        .labels {
          padding-left: 13px;
          display: flex;
          flex-wrap: wrap;
          column-gap: 10px;
          label {
            font-size: 15px;
            height: 15px;
            display: flex;
            align-items: center;
            margin: 7px 0 12px;
            letter-spacing: -1.6px;
            min-width: 83px;
            input {
              margin-right: 2px;
            }
          }
        }
        .selects {
          font-size: 16px;
          padding: 0 13px;
          select {
            width: 30%;
            height: 20px;
            border: none;
            margin-right: 4px;
          }
        }
      }
      select {
        margin-top: 10px;
      }
      &.in_sidebar {
        .selects {
          font-size: 12px;
          select {
            font-size: 12px;
            color: #015205;
            font-weight: bold;
          }
        }
        .pc label {
          cursor: pointer;
        }
      }
      &.in_modal {
        margin-top: 0;
        border-top: 0;
        padding: 0;
        .labels {
          padding-left: 0;
          row-gap: 11.4vw;
          column-gap: 0;
          margin-bottom: 7vw;
          label {
            width: 50%;
            color: #6c6c6c;
            font-size: 4.6875vw;
            font-weight: 700;
            display: flex;
            align-items: center;
            a {
              font-size: 4.6875vw;
              text-decoration: underline;
              color: #6c6c6c;
            }
            input {
              display: none;
            }
            .checkbox-icon {
              height: 6.40625vw;
              width: 6.40625vw;
              margin-right: 3.6vw;
              &.hidden {
                display: none;
              }
            }
          }
        }
        .selects {
          color: #a1a1a1;
          padding: 0;
          display: flex;
          align-items: center;
          font-size: 5vw;
          .select-wrap {
            width: 40.625vw;
            display: flex;
            align-items: center;
            position: relative;
            &::after {
              content: "▼";
              color: #a1a1a1;
              font-size: 5vw;
              line-height: 1;
              position: absolute;
              top: calc(50% - 2.5vw);
              right: 2.1875vw;
            }
          }
          select {
            border: 0.46875vw solid #e8e8e8;
            color: #5b5b5b;
            font-size: 4.6875vw;
            font-weight: 700;
            height: 15.625vw;
            width: 40.625vw;
            appearance: none;
            background: #ffffff;
            margin: 0;
            padding-left: 3.28125vw;
          }
        }
      }
    }
  script.
    import checkboxOnIcon from 'tags/smartsearch/checkbox_t.png'
    import checkboxOffIcon from 'tags/smartsearch/checkbox_f.png'
    import SmartsearchMaster from 'models/smartsearch-master.js'

    export default {
      checkboxOnIcon,
      checkboxOffIcon,
      didSelectPriceRange() {
        const bottom = Number(document.querySelector('.price-checkboxes #price_bottom').value)
        const top = Number(document.querySelector('.price-checkboxes #price_top').value)
        const blankBottom = !bottom && bottom !== 0
        if (blankBottom && !top || top <= bottom) {
          this.state.selectedPriceRange = undefined
          this.update({ selectedPriceRange: undefined })
          this.didChangePriceRange()
          return
        }
        if (blankBottom || !top) return
        this.update({ selectedPriceRange: bottom + '-' + top })
        this.didChangePriceRange()
      },
      didChangePriceRange() {
        const priceRangeElements = document.querySelectorAll(`.price-checkboxes .checkboxes.${this.props.type} input`)
        const priceRanges = Array.prototype.map.call(priceRangeElements, (c) => {
          return c.checked || c.type == 'hidden' ? c.value : ''
        }).filter(range => range.length > 0)
        const priceRangeQuery = [...new Set(priceRanges)].join(',')
        this.update({
          priceRangeQuery
        })
        this.props.onUpdate(priceRangeQuery)
      },
      initializeByExistQuery() {
        const result = (new RegExp('[?&]'+encodeURIComponent('pr')+'=([^&]*)')).exec(location.search)
        if(!result) return
        this.state.priceRangeQuery = decodeURIComponent(result[1])
        this.state.existPriceRanges = decodeURIComponent(result[1]).split(',')
        const selectedPriceRange = this.state.existPriceRanges.filter( (range) => {
          return !this.state.priceRangeMasters.map( rangeMaster => rangeMaster.range ).includes(range)
        })
        if(selectedPriceRange.length < 1) {
          this.update()
          return
        }

        this.state.selectedPriceRange = selectedPriceRange[0]
        const selectedPrices = selectedPriceRange[0].split('-')
        if(selectedPrices.length < 2) {
          this.update()
          return
        }

        this.update({
          initialBottom: selectedPrices[0],
          initialTop: selectedPrices[1]
        })
      },
      urlFromValueWithFormData(value) {
        const queryKey = 'pr'
        if (!this.props.formdata) return

        const formDataObj = Object.fromEntries(Array.from(this.props.formdata.entries()))

        const currentValues = (this.state.priceRangeQuery || '').split(',')
        if (!currentValues.includes(value)) {
          const values = Array.from(this.state.priceRangeValues).filter( v => (currentValues.includes(v)) )
          if (!values.includes(value)) values.push(value)
          formDataObj[queryKey] = values.join(',')
        }
        const formDataArray = Array.from(Object.entries(formDataObj)).sort( (kv1, kv2) => {
          if (kv1 < kv2) { return -1 }
          else if (kv1 > kv2) { return 1 }
          else return 0
        })
        const url = '/watches/?' + formDataArray.filter( kv => !!kv[1] ).map( kv => kv[0] + '=' + kv[1] ).join('&')
        return url
      },
      priceRangeQuery(priceRange) {
        return `${priceRange["price_bottom"]}-${priceRange["price_top"] || 999999999}`
      },
      onBeforeMount(props, state) {
        const masterData = new SmartsearchMaster()
        const minPrice = props.minPrice ? Number(props.minPrice) : undefined
        const maxPrice = props.maxPrice ? Number(props.maxPrice) : undefined
        const masters = masterData.priceRangeMasters
        state.priceRangeMasters = !minPrice && !maxPrice ? masters : masters.filter(current => {
          const range = current.range.split('-').map(Number)
          if (!minPrice && !maxPrice) return true
          if (!!minPrice && range[1] < minPrice) return false
          if (!!maxPrice && range[0] > maxPrice) return false
          return true
        })
        state.priceMasters = masterData.priceMasters
        state.priceRangeValues = state.priceRangeMasters.map(current => current.range)
        state.shouldnofollow = props.shouldnofollow
        state.initialBottom = 0
        state.initialTop = 999999999
        state.existPriceRanges = []
        state.priceranges = props.priceranges ? JSON.parse(props.priceranges) : []
      },
      onMounted(props, state) {
        this.initializeByExistQuery()
        this.update()
      },
      onUpdated(props, state) {
      }
    }
